export const MEDIA_ARCHIVE = 'MEDIA_ARCHIVE';
export const MEDIA_ON = 'MEDIA_ON';
const EMPTY_OBJ = Object.freeze({});

// Retrieves the media item from broadcast epg for a game
const getMediaItem = (broadcasts = EMPTY_OBJ) => {
    let mediaItem;
    for (let i = 0; i < broadcasts?.length; i++) {
        const { type, homeAway, mediaState: { mediaStateCode }, availableForStreaming } = broadcasts[i];
        if (type === 'TV' && availableForStreaming) {
            // First choice
            if (mediaStateCode === MEDIA_ON) {
                mediaItem = broadcasts[i];
                break;
                // Good enough choice unless first choice
            } else if (!mediaItem && mediaStateCode === MEDIA_ARCHIVE) {
                mediaItem = broadcasts[i];
            }
        }
    }

    return mediaItem;
};

// Retrieves the media state from broadcast epg for a game
const getMediaState = (broadcasts = EMPTY_OBJ) => {
    return getMediaItem(broadcasts)?.mediaState?.mediaStateCode;
};

// Retrieves the media item from the content epg for a game
const getContentMediaItem = (content = EMPTY_OBJ) => {
    let mediaItem;
    const mediaArr = content.media?.epg ?? [];

    for (let i = 0; i < mediaArr.length; i++) {
        const { title, items } = mediaArr[i];
        if (title === 'MLBTV' || title === 'MiLBTV') {
            for (let j = 0; j < items.length; j++) {
                const mediaItemState = items[j].mediaState;

                // if any of the states are MEDIA_ON that is highest priority and can break loop
                // otherwise if MEDIA_ARCHIVE set as state and keep checking for MEDIA_ON
                if (mediaItemState === MEDIA_ON) {
                    mediaItem = items[j];
                    break;
                } else if (mediaItemState === MEDIA_ARCHIVE) {
                    mediaItem = items[j];
                }
            }
        }
    }
    return mediaItem;
};

// Retrieves the media state from the content epg for a game
const getContentMediaState = (content = EMPTY_OBJ) => {
    return getContentMediaItem(content)?.mediaState;
};

export { getContentMediaState, getContentMediaItem, getMediaState, getMediaItem };
export default getMediaState;
